import React, { Component } from 'react';
// import { BrowserRouter, Link } from 'react-router-dom';
// import axios from 'axios';

// components
// import Search from '../singlets/Search';

export class TopBar extends Component  {
  state = {
    topbar: []
  }

  componentDidMount() {
    // const getTopMenu = axios.get('https://www.usa.edu/wp-json/wp-api-menus/v2/menus/6');

    // Promise.all([getTopMenu]).then(res => {
    //   // console.dir(res);
    //   this.setState({
    //     topbar: res[0].data.items
    //   });
    // });
  }

  render() {
    // const { topbar } = this.state;

    return (
      <>
        <div id="top-bar">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {/* <ul>
                  {topbar.map(nav =>
                    <li key={ nav.id } className={ nav.classes }> <a href={ nav.url } dangerouslySetInnerHTML={{ __html: nav.title }} /> </li>
                  )}
                </ul> */}

                <ul>
                  <li className="alignleft">
                    <a href="https://my.usa.edu/ics"><i className="fa fa-sign-in" aria-hidden="true"></i> MyUSA</a>
                  </li>
                  <li className="alignleft">
                    <a href="https://library.usa.edu"><i className="fa fa-book" aria-hidden="true"></i> Library</a>
                  </li>
                  <li className="alignleft">
                    <a href="https://university-of-st-augustine-gear-store.myshopify.com/"><i className="fa fa-shopping-cart" aria-hidden="true"></i> Gear Store</a>
                  </li>
                  <li className="alignleft">
                    <a href="https://usa-cpe.edubrite.com/oltpublish/site/cms.do"><i className="fa fa-laptop" aria-hidden="true"></i> Continuing Education</a>
                  </li>

                  <li className="alignright highlight fancybox-inline rfi-form-button"> <a href="https://www.usa.edu/request-information/">Request Information</a> </li>
                  <li className="alignright"> <a href="https://www.usa.edu/apply/">Apply Now</a> </li>
                </ul>

                {/* <Search /> */}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default TopBar;